module.exports = __webpack_public_path__ + "static/media/carga_masiva_empleado.620a5099.png";